import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { PlatformDetectorService } from 'src/app/core/services/platform-detector.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';

@Component({
    templateUrl:'./forgot.component.html',
    styleUrls:  ['./forgot.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ForgotComponent implements OnInit{

    forgotForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder, 
        private authService: AuthService,
        private router: Router,
        private platformDetectorService: PlatformDetectorService,
        private notificationsService: NotificationsService
    ){}

    
    ngOnInit(): void {

        this.forgotForm = this.formBuilder.group({
            userName:['', Validators.required]
         } );
    }

    resetar(){
        const userName = this.forgotForm.get('userName').value;

        this.authService
            .resetPass(userName)
            .subscribe(
                () =>{
                    this.notificationsService.toastNotify('success','Restar Senha', 'Foi enviado um link para efetuar a alteração de senha no e-mail informado!');
                
                    this.router.navigate(['/'])
                }, 
                err=>{
                    console.log(err);
                    this.forgotForm.reset();
                    alert("email não encontrado.")
                    
                }
            );
    }
}